import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preset", "pickerButton", "field"]

  connect() {
    this.refreshMaximum()
    this.updateSelection()
  }

  select(event) {
    const daysAgo = parseInt(event.currentTarget.dataset.daysAgo)
    this.refreshMaximum()
    this.fieldTarget.value = this.dateString(daysAgo)
    this.fieldTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  showPicker() {
    this.refreshMaximum()
    this.fieldTarget.focus()

    // Safari dismisses its picker when the input blurs, so focus it before opening.
    try {
      if (this.fieldTarget.showPicker) {
        this.fieldTarget.showPicker()
      } else {
        this.fieldTarget.click()
      }
    } catch {
      this.fieldTarget.click()
    }
  }

  refreshMaximum() {
    this.fieldTarget.max = this.dateString(0)
  }

  fieldChanged() {
    this.updateSelection()
  }

  updateSelection() {
    const value = this.fieldTarget.value
    const matched = this.presetTargets.find(preset =>
      this.dateString(parseInt(preset.dataset.daysAgo)) === value
    )

    if (matched) {
      this.resetPickerLabel()
      this.highlight(matched)
    } else if (value) {
      this.pickerButtonTarget.textContent = this.shortFormat(value)
      this.highlight(this.pickerButtonTarget)
    } else {
      this.resetPickerLabel()
      this.highlight(null)
    }
  }

  highlight(selected) {
    const buttons = [...this.presetTargets, this.pickerButtonTarget]

    buttons.forEach(button => {
      if (button === selected) {
        button.classList.add("border-transparent", "ring-1", "ring-warm-gray-800", "text-warm-gray-900")
        button.classList.remove("border-warm-gray-300", "text-warm-gray-700", "hover:bg-warm-gray-50")
      } else {
        button.classList.remove("border-transparent", "ring-1", "ring-warm-gray-800", "text-warm-gray-900")
        button.classList.add("border-warm-gray-300", "text-warm-gray-700", "hover:bg-warm-gray-50")
      }
    })
  }

  resetPickerLabel() {
    this.pickerButtonTarget.textContent = "Pick a date"
  }

  shortFormat(value) {
    const [year, month, day] = value.split("-").map(Number)
    const date = new Date(year, month - 1, day)

    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" })
  }

  dateString(daysAgo) {
    const date = new Date()
    date.setDate(date.getDate() - daysAgo)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")

    return `${year}-${month}-${day}`
  }
}
